<template>
  <section class="container">
    <div class="news-detail">
      <div class="news-detail__content">
        <div class="detail">
          <div class="detail__content">
            <div class="news-detail__head">
              <h1 class="news-detail__head-title">
                {{ NewsData.newsSubject }}
              </h1>
              <p class="news-detail__head-date">
                {{ NewsData.newsStartDate | toTaipei | moment('YYYY-MM-DD') }}
              </p>
            </div>

            <p v-html="NewsData.newsContent" />
            <a v-if="NewsData.newsLink" :href="NewsData.newsLink" target="_blank">{{ $t('news.relatedLink') }}</a>
          </div>
        </div>
      </div>

      <div class="news-detail__footer">
        <router-link class="" to="/news">
          {{ $t('news.button.backToList') }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { GetNewsById } from '@/api/NewsApi';

export default {
  data() {
    // 建立你的初始化 model data
    return {
      NewsData: {
        newsCategoryId: 1,
        newsContent: '',
        newsEndDate: null,
        newsId: 0,
        newsLink: '',
        newsStartDate: null,
        newsSubject: '',
        noticeDate: null,
        status: 0,
      },
    };
  },
  created() {
    this.GetNews();
  },
  methods: {
    GetNews() {
      // 取得 url id 的方法
      const { id } = this.$route.params;
      GetNewsById(id).then((response) => {
        if (response.data.statusCode === 0) {
          this.NewsData = response.data.data;
          this.$emit('update:currentPage', {
            name: '',
            title: this.NewsData.newsSubject,
            path: '',
          });
        } else if (response.data.statusCode === 7920008) {
          this.$router.replace('/');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.news-detail {
  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 20px;
    margin-bottom: 30px;
    background-color: #f1f1f1;
    border-radius: 5px;

    @media (max-width: 991px) {
      flex-wrap: wrap;
      padding: 10px;
      margin-bottom: 20px;
    }

    &-title {
      font-size: 20px;
      font-weight: 700;
      color: #333;

      @media (max-width: 991px) {
        width: 100%;
        font-size: 18px;
      }
    }

    &-date {
      color: var(--primary-color);

      @media (max-width: 991px) {
        font-size: 15px;
      }
    }
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;

    a {
      color: #777;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
